import { arrayOf, objectOf, anyOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

const isOauthMcpRedirectUri = objectOf({
  uri: string,
  state: string,
  marketplace_client_keys: arrayOf(string),
  last_updated_by_id: anyOf(nullOrUndefined, string),
  last_updated_by_name: string,
  last_updated_at: string,
});

export const isGetCompaniesCompanyIdOauthMcpSettingsResult = objectOf({
  mcp_server_enabled: boolean,
  redirect_uris: arrayOf(isOauthMcpRedirectUri),
});
